import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

export function ImgEditGlitchMob(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      height={450}
      alt='Edit / Glitch Mob'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Home_04_1_edIT_540x.jpg?v=1623924015'
    />
  );
}

export function ImgMartinGore(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      height={450}
      alt='Martin Gore'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Home_04_2_martin_gore.jpg?v=1623924092'
    />
  );
}

export function ImgAndrewHuang(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={450}
      layout='constrained'
      alt='Andrew Huang'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Home_04_3_andrew_huang_720x.jpg?v=1623924122'
    />
  );
}

export function ImgJJ(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={450}
      layout='constrained'
      alt='JJ Abrams'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Home_04_4_jj_abrams.jpg?v=1623924149'
    />
  );
}

export function ImgRona(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={450}
      layout='constrained'
      alt='Jeff Rona'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Home_04_5_jeff_rona_720x.jpg?v=1623924164'
    />
  );
}

export function ImgRicky(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={450}
      layout='constrained'
      alt='Rickey Tinez'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Ricky_tinez_1296x.jpg'
    />
  );
}

export function ImgTeam(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='NE Team'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/NE-4-square.png?v=1730327491'
    />
  );
}

export function ImgMainHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='POB shows off his Noise Engineering setup'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/11.png?v=1742508863'
    />
  );
}

export function ImgBIAHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Basimilus Iteritas Alia'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/basimilus-iteritas-alia-black-1024x2048.png?v=1697645947&width=320&crop=center'
    />
  );
}
export function ImgDysHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Dystorpia'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/NE_Dystorpia_cropped-FINAL.png?v=1732129584'
    />
  );
}
export function ImgSAndK(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='Stephen and Kris'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Home05-Stephen_and_kris_outside_900x900_crop_center.jpg?v=1623927006'
    />
  );
}

export function ImgPluginHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Plugins'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/basimilus_1.png?v=1720481442'
    />
  );
}

export function ImgPluginsHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='Plugins'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/plugins-2048.png?v=1730843813'
    />
  );
}

export function ImgMayaMnts(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='The Maya Mountains of the Belizean rainforest as viewed from mount Outlier'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/IMG_3250.jpg?v=1715376070'
    />
  );
}

export function ImgPartners(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='Sunset at the headwaters of the Amazon River.'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Sunset_on_the_Ucayali.jpg?v=1715375622'
    />
  );
}

export function ImgMargaret(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='Sunset from Mount Maragaret, Belize. Red rays shine through clouds and the sun is brilliantly yellow against a deepening blue sky.'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Mount_Margaret_Sunset.jpg?v=1715376137'
    />
  );
}

export function ImgAliaPanels(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='Alia Panels'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/world-of-alia.png?v=1733880265'
    />
  );
}

export function ImgLibDaisy(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='A blurred screenshot in darkmode of libDaisy with the word libDaisy in front and a pink circle and arrow head pointing upward.'
      src='./libdaisy.jpg'
    />
  );
}

export function ImgPlatform(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='Versio, Legio, and Alia platform modules on a grey background with lots of dots. A purple USB cable symbol is superimposed. Platform modules are freely updateable. | Noise Engineering'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/platforms.png?v=1697570047'
    />
  );
}

export function ImgModules(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='A smattering of NE modules on a background with grey dots | Noise Engineering'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/modules-2048.png?v=1730843998'
    />
  );
}

export function ImgSwapable(props: any) {
  return (
    <StaticImage
      height={50}
      layout='constrained'
      alt='Noise Engineering pentagon'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/star.png?v=1723058561'
    />
  );
}

export function ImgBigSound(props: any) {
  return (
    <StaticImage
      height={50}
      alt='Noise Engineering shell'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/shell.png?v=1723058560'
    />
  );
}

export function ImgFirmwares(props: any) {
  return (
    <StaticImage
      height={50}
      alt='Noise Engineering diamond'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/diamond.png?v=1723058561'
    />
  );
}

export function ImgSwapAlia(props: any) {
  return (
    <StaticImage
      alt=''
      height={50}
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/basimilus.png?v=1723058436'
    />
  );
}

export function ImgSwapVersio(props: any) {
  return (
    <StaticImage
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/designed-by-us.png?v=1723058063'
      alt='Noise Engineering prism'
      height={50}
      layout='constrained'
    />
  );
}

export function ImgSoundsAlia(props: any) {
  return (
    <StaticImage
      height={50}
      alt=''
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/manis.png?v=1723058435'
    />
  );
}

export function ImgBoomAlia(props: any) {
  return (
    <StaticImage
      alt=''
      height={50}
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/debel.png?v=1723058436'
    />
  );
}

export function ImgPanelLegio(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='All Noise Engineering Legio panels'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/world_of_legio-7.png?v=1732747376'
    />
  );
}

export function ImgConservationLegio(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      alt='Versio, Legio, and Alia platform modules on a grey background with lots of dots. A purple USB cable symbol is superimposed. Platform modules are freely updateable. | Noise Engineering'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/platforms.png?v=1697570047'
    />
  );
}

export function ImgDoomVersio(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={50}
      layout='constrained'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Community_giveback_31b7f51e-0ffc-4c20-abe0-01bf642b43db.png?v=1723058063'
      alt='Noise Engineering bat'
    />
  );
}

export function ImgOpenSource(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={50}
      layout='constrained'
      alt='Noise Engineering evil eye'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/Sunny_california_afa08a51-83d2-4a87-b09d-64fbff429732.png?v=1723058064'
    />
  );
}
``;

export function ImgPanelsVersio(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      layout='constrained'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/world_of_versio-10.png?v=1734118478'
      alt='All Versio panels with text that says World of Versio'
    />
  );
}

export function ImgAliaHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Basimilus Iteritas Alia'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_basimilus-iteritas-alia-black.png?v=1720741114'
    />
  );
}

export function ImgLegioHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Roucha Legio'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_roucha-legio-black.png?v=1720741118'
    />
  );
}

export function ImgVersioHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Desmodus Versio'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_desmodus-versio-black.png?v=1720741116'
    />
  );
}
export function ImgEffectsHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Desmodus Versio'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_desmodus-versio-black.png?v=1720741116'
    />
  );
}

export function ImgNewHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Gamut Repetitor'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_gamut-repetitor-black.png?v=1720741119'
    />
  );
}

export function ImgDistortionHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Ruina Versio'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_ruina-versio-black.png?v=1720741118'
    />
  );
}
export function ImgUtilityHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Lapsus Os'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_lapsus-os-black.png?v=1720741118'
    />
  );
}

export function ImgSequencingHero(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Mimetic Digitalis'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/2024_mimetic-digitalis-black.png?v=1720741112'
    />
  );
}

export function ImgIndustrial(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Shop Industrial'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/industrial-background.png?v=1724785533'
    />
  );
}

export function ImgCinematic(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Shop Cinematic'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/cinematic-background.png?v=1724785533'
    />
  );
}

export function ImgTechno(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Shop Techno'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/techno-background.png?v=1724785533'
    />
  );
}

export function ImgAmbient(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Shop Ambient'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/ambient-background.png?v=1724785533'
    />
  );
}

export function ImgGlitch(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Shop Glitch'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/glitch-background.png?v=1724785531'
    />
  );
}

export function ImgSoCal(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={300}
      layout='constrained'
      alt='Designed and made in sunny Southern California'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/4_24987e87-2833-42d1-b5da-797a3c90ed31.png?v=1739325419'
    />
  );
}

export function ImgArtistApp(props: any) {
  return (
    <StaticImage
      objectFit='scale-down'
      height={200}
      layout='constrained'
      alt='The Noise Engineering Artist Program'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/ne-bat-logo.png?v=1740187096'
    />
  );
}

export function ImgLifestyle1(props: any) {
  return (
    <StaticImage
      objectFit='fill'
      layout='constrained'
      alt='The Noise Engineering Artist Program'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/01.png?v=1742508861'
    />
  );
}

export function ImgLifestyle9(props: any) {
  return (
    <StaticImage
      objectFit='fill'
      layout='constrained'
      alt='Noise Engineering products in action'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/09.png?v=1742508863'
    />
  );
}

export function ImgLifestyle7(props: any) {
  return (
    <StaticImage
      objectFit='fill'
      layout='constrained'
      alt='Noise Engineering products in action'
      src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/07.png?v=1742508863'
    />
  );
}
